"use strict";

exports.__esModule = true;
exports.Weekday = exports.RenderDay = exports.Navbar = exports.Caption = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _glyph = _interopRequireDefault(require("../glyph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var LeftChevron = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "components__LeftChevron",
  componentId: "sc-jz65rz-0"
})(["position:absolute;left:16px;top:22px;transform:translateY(-50%);"]);
var RightChevron = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "components__RightChevron",
  componentId: "sc-jz65rz-1"
})(["position:absolute;right:16px;top:22px;transform:translateY(-50%);"]);
var CaptionBar = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "components__CaptionBar",
  componentId: "sc-jz65rz-2"
})(["display:table-caption;border-bottom:1px solid;"]);
var WeekdayBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "components__WeekdayBox",
  componentId: "sc-jz65rz-3"
})(["display:table-cell;"]);

var RenderDay = function RenderDay(day) {
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-dark",
    fontSize: 1,
    fontWeight: 2,
    lineHeight: 3,
    py: "5px",
    textAlign: "center"
  }, day.getDate());
};

exports.RenderDay = RenderDay;
RenderDay.displayName = "Modules.RenderDay";

var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return /*#__PURE__*/_react["default"].createElement(WeekdayBox, {
    className: className,
    py: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-helper",
    fontSize: 0,
    fontWeight: 1,
    lineHeight: 3,
    py: "4px",
    textAlign: "center",
    title: weekdayName
  }, weekdayName.slice(0, 3)));
};

exports.Weekday = Weekday;
Weekday.propTypes = {
  /** A string to represent the class name for the WeekdayBox */
  className: _propTypes.string,

  /** A string to represent the locale information */
  locale: _propTypes.string,

  /** Functions to format the weekday based on locale */
  localeUtils: (0, _propTypes.shape)({
    formatWeekdayLong: _propTypes.func
  }),

  /** A number to represent the weekday */
  weekday: _propTypes.number
};
Weekday.displayName = "Modules.Weekday";

var Navbar = function Navbar(_ref2) {
  var onPreviousClick = _ref2.onPreviousClick,
      onNextClick = _ref2.onNextClick;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(LeftChevron, {
    height: 16,
    onClick: function onClick() {
      return onPreviousClick();
    },
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    fill: "icon-input",
    id: "caret-left"
  })), /*#__PURE__*/_react["default"].createElement(RightChevron, {
    height: 16,
    onClick: function onClick() {
      return onNextClick();
    },
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    fill: "icon-input",
    id: "caret-right"
  })));
};

exports.Navbar = Navbar;
Navbar.propTypes = {
  /** onClick event handler - used to process the event */
  onNextClick: _propTypes.func,

  /** onClick event handler - used to process the event */
  onPreviousClick: _propTypes.func
};
Navbar.displayName = "Modules.Navbar";

var Caption = function Caption(_ref3) {
  var date = _ref3.date,
      months = _ref3.months,
      locale = _ref3.locale,
      localeUtils = _ref3.localeUtils,
      onClick = _ref3.onClick;
  return /*#__PURE__*/_react["default"].createElement(CaptionBar, {
    color: "border",
    mx: -16,
    px: 1,
    py: 13
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "text-title",
    fontSize: 2,
    fontWeight: 1,
    lineHeight: 2,
    onClick: onClick,
    role: "heading",
    textAlign: "center"
  }, months ? months[date.getMonth()] + ", " + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
};

exports.Caption = Caption;
Caption.propTypes = {
  /** instance of type Date */
  date: (0, _propTypes.instanceOf)(Date),

  /** A string to represent the locale information */
  locale: _propTypes.string,

  /** Functions to format the month based on locale */
  localeUtils: (0, _propTypes.shape)({
    formatMonthTitle: _propTypes.func
  }),

  /** A number to represent the months */
  months: _propTypes.number,

  /** onClick handler to process the event */
  onClick: _propTypes.func
};
Caption.displayName = "Modules.Caption";